var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex justify-between align-center w-full" },
    [
      _c(
        "div",
        { staticClass: "w-1/3 mr-3 mb-2" },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "Email",
              tag: "div",
              vid: _vm.emailFieldName,
              immediate: _vm.immediate,
              rules: _vm.customRules,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        placeholder: "email@businessname.com",
                        errors: _vm.getErrors(errors, changed),
                        value: _vm.localEmail,
                        processing: _vm.processing,
                        name: _vm.emailFieldName,
                        debounceTime: 500,
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleEmailUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.emailFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.emailFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm.regexError
                      ? _c("span", { staticClass: "regex-error" }, [
                          _vm._v(_vm._s(_vm.regexError)),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "w-1/3 mr-3 mb-2" },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "First name",
              rules: "required_field|c_name",
              tag: "div",
              vid: _vm.nameFieldName,
              immediate: _vm.immediate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        name: "csv_item_given_name",
                        placeholder: "Enter first name",
                        value: _vm.userGivenName,
                        errors: _vm.validateCsv || changed ? errors : [],
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleGivenNameUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.firstNameFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.firstNameFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "w-1/3 mr-3 mb-2" },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "Last name",
              rules: "required_field|c_name",
              tag: "div",
              vid: _vm.surnameFieldName,
              immediate: _vm.immediate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        name: "csv_item_family_name",
                        placeholder: "Enter last name",
                        value: _vm.userFamilyName,
                        errors: _vm.validateCsv || changed ? errors : [],
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleFamilyNameUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.lastNameFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.lastNameFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      !_vm.isManager
        ? _c(
            "div",
            { staticClass: "w-1/12 mr-3 mt-6 mb-2" },
            [
              _c(
                "ValidationProvider",
                {
                  attrs: {
                    name: "Last name",
                    tag: "div",
                    vid: _vm.isPublicFieldName,
                  },
                },
                [
                  _c("FormToggle", {
                    attrs: {
                      label: _vm.is_public ? "Open Access" : "Limited Access",
                      checked: _vm.is_public,
                    },
                    on: {
                      toggle: function ($event) {
                        return _vm.toggleIsPublic(_vm.is_public)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w-1/3 mr-3" },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "Company",
              rules: "c_name",
              tag: "div",
              vid: _vm.companyFieldName,
              immediate: _vm.immediate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        name: "csv_item_company_name",
                        placeholder: "Enter company name",
                        value: _vm.userCompanyName,
                        errors: _vm.validateCsv || changed ? errors : [],
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleCompanyUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.companyFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.companyFieldTitle)),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "text-sub-heading" },
                                      [_vm._v("(optional)")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "ml-auto", class: _vm.animationClass }, [
        _c(
          "button",
          {
            staticClass:
              "block w-5 h-8 mb-2 mt-1 text-gray-400 hover:text-gray-500 focus:outline-none disabled:text-gray-300",
            class: _vm.deleteButtonStyles,
            attrs: {
              type: "button",
              id: "userInvitation",
              disabled: !_vm.allowDelete,
            },
            on: { click: _vm.handleRemoveClick },
          },
          [_c("CrossIconBlack")],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }